import { User } from "../types";
import ResourceService from "../common/Services/ResourceService";

class UserService extends ResourceService<User> {
  constructor() {
    super({
      path: "/users",
      queryKey: "users",
    });
  }

  static listUsers() {
    return new UserService().list();
  }

  static fetchUser(id: User["id"]) {
    return new UserService().fetch({ id });
  }

  static createUser(payload?: Partial<User>) {
    return new UserService().create(payload);
  }

  static updateUser(id: User["id"], payload: Partial<User>) {
    return new UserService().update({ ...payload, id });
  }

  static deleteUser(id: User["id"]) {
    return new UserService().deleteOne({ id });
  }
}

export default UserService;
